<template>
  <div class="select-user">
    <div class="switch pointer" @click="toggleType">
      {{ typeTip }}
      <i class="el-icon-arrow-right"></i>
    </div>
    <div class="body-wrapper">
      <!--人员选择-->
      <div v-if="isUserList" class="option-wrapper">
        <div
          class="scroll-wrapper"
          ref="userWrapper"
          @ps-y-reach-end="showMore"
          key="user-scroll-wrapper"
          v-ps
        >
          <el-checkbox-group :value="selected">
            <el-checkbox
              v-for="u in userForShow"
              :key="u.id"
              :label="u.id"
              @change="userChange($event, [u.id])"
            >
              <staff-avatar class="avatar" :size="26" :user="u"></staff-avatar>
              {{ u.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <!--部门选择-->
      <div v-else class="department-wrapper">
        <div ref="breadcrumb" key="breadcrumb" class="breadcrumb">
          <div class="breadcrumb-item" @click="changeBreadcrumb(-1)">
            <div class="text">全部</div>
          </div>
          <div class="breadcrumb-item" v-for="(node, idx) in treePath" :key="node">
            <div style="margin: 0 5px;">&gt;</div>
            <div class="text" @click="changeBreadcrumb(idx)">
              {{ departmentMap[node].name }}
            </div>
          </div>
        </div>
        <div class="scroll-wrapper" v-ps>
          <el-checkbox-group :value="currentDepartmentSelected">
            <div class="checkbox-wrapper" v-for="d in currentDepartments" :key="d.id">
              <el-checkbox
                :indeterminate="indeterminateMap[d.id]"
                :label="d.id"
                :disabled="!departmentUserSetMap[d.id] || departmentUserSetMap[d.id].size == 0"
                @change="departmentChange($event, [d.id])"
              >
                {{ " " }}
              </el-checkbox>
              <div class="name-wrapper pointer" @click="stepInfoSubDepartment(d.id)">
                <span>{{ d.name }}</span>
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </el-checkbox-group>
          <el-checkbox-group :value="currentUserSelected">
            <el-checkbox
              v-for="u in currentUsers"
              :key="u.id"
              :label="u.id"
              @change="userChange($event, [u.id])"
            >
              <staff-avatar class="avatar" :size="26" :user="u"></staff-avatar>
              {{ u.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calcDepartmentIdAllUserIdSetMap, calcDepartmentIdUserIdSetMap } from "@/utils/user"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "SelectUser",
  components: { StaffAvatar },
  props: {
    selected: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    rootDepartment: {
      type: Object,
      default: () => ({})
    },
    departmentMap: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      width: 300,
      showCount: 10,
      isUserList: true,
      // 部门选择状态下,面包屑导航路径
      treePath: []
    }
  },
  computed: {
    userForShow() {
      return this.users.slice(0, this.showCount)
    },
    typeTip() {
      return this.isUserList ? "按组织架构查看" : "按人员列表查看"
    },
    departmentUserMap() {
      return calcDepartmentIdUserIdSetMap(this.users)
    },
    departmentUserSetMap() {
      // 部门下面所有用户的集合, 辅助部门状态计算
      return calcDepartmentIdAllUserIdSetMap(this.rootDepartment, this.users)
    },
    userMap() {
      return this._.keyBy(this.users, "id")
    },
    indeterminateMap() {
      let map = {}
      this.currentDepartments.forEach(department => {
        let curDepartmentUsers = this.departmentUserSetMap[department.id]
        let count = 0
        this.selected.forEach(selectedUserId => {
          if (curDepartmentUsers.has(selectedUserId)) {
            count++
          }
        })
        map[department.id] = count != 0 && count < curDepartmentUsers.size
      })
      return map
    },
    curDepartmentId() {
      return this.treePath.length > 0
        ? this.treePath[this.treePath.length - 1]
        : this.rootDepartment.id
    },
    currentUsers() {
      // 部门选择状态下,部门人员
      return Array.from(this.departmentUserMap[this.curDepartmentId] || []).map(
        userId => this.userMap[userId]
      )
    },
    currentUserSelected() {
      return this.currentUsers.filter(user => this.selected.includes(user.id)).map(u => u.id)
    },
    currentDepartments() {
      // 部门选择状态下,部门列表
      return this.departmentMap[this.curDepartmentId]?.children || []
    },
    currentDepartmentSelected() {
      return this.currentDepartments
        .filter(department => {
          // 当部门所有人都已选中时,把部门直接选中
          let curDptUserIdSet = this.departmentUserSetMap[department.id]
          return (
            curDptUserIdSet.size > 0 &&
            Array.from(curDptUserIdSet).filter(userId => !this.selected.includes(userId)).length ==
              0
          )
        })
        .map(d => d.id)
    }
  },
  methods: {
    showMore() {
      if (!this.$refs.userWrapper?.clientHeight) return // 此时是处于隐藏状态
      this.showCount = Math.min(this.users.length, this.showCount + 10)
    },
    initBreadcrumbPosition() {
      // 处理滚动:自动滚动在最右边
      this.$nextTick(() => {
        let breadcrumb = this.$refs.breadcrumb
        breadcrumb.scrollLeft = breadcrumb.scrollWidth - this.width + 24
      })
    },
    toggleType() {
      this.isUserList = !this.isUserList
      if (!this.isUserList) {
        this.initBreadcrumbPosition()
      }
    },
    stepInfoSubDepartment(departmentId) {
      this.treePath.push(departmentId)
      this.initBreadcrumbPosition()
    },
    changeBreadcrumb(idx) {
      this.treePath = this.treePath.slice(0, idx + 1)
      this.initBreadcrumbPosition()
    },
    userChange(isAdd, ids) {
      this.$emit("change", { isAdd, ids })
    },
    departmentChange(isAdd, departmentId) {
      this.userChange(isAdd, Array.from(this.departmentUserSetMap[departmentId]))
    }
  }
}
</script>

<style lang="scss" scoped>
.select-user {
  .switch {
    height: 36px;
    background: #f5f7fa;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .el-icon-arrow-right {
      margin-left: auto;
    }
  }
  .body-wrapper {
    padding: 6px 6px 6px 12px;
    .breadcrumb {
      display: flex;
      overflow: hidden;
      .breadcrumb-item {
        display: flex;
        flex: 0 0 auto;
        .text {
          color: #407fff;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        &:last-of-type {
          .text {
            color: unset;
            cursor: unset;
            &:hover {
              text-decoration: unset;
            }
          }
        }
      }
    }
  }
  .scroll-wrapper {
    max-height: 200px;
    min-height: 50px;
    position: relative;
    .el-checkbox-group {
      display: flex;
      flex-flow: column;
      /*自定义文字显示*/
      .checkbox-wrapper {
        display: flex;
        position: relative;
        align-items: center;
        height: 40px;
        .name-wrapper {
          height: 100%;
          flex: 1;
          font-size: 14px;
          display: flex;
          align-items: center;
        }
        .el-icon-arrow-right {
          font-size: 14px;
          position: absolute;
          right: 0px;
          top: 12px;
        }
        &:hover {
          background-color: #f0f4fd;
        }
      }
      .el-checkbox {
        display: flex;
        align-items: center;
        margin-right: 0;
        height: 40px;
        &:hover {
          background-color: #f0f4fd;
        }
        ::v-deep .el-checkbox__label {
          display: flex;
          align-items: center;
          overflow: hidden;
          .avatar {
            margin-right: 6px;
          }
        }
      }
    }
  }
}
</style>
